// extracted by mini-css-extract-plugin
export default {"page-container":"styles_page-container__SS-7-","bottom-sheet":"styles_bottom-sheet__2Uw14","bottom-sheet-safe-area":"styles_bottom-sheet-safe-area__gD7HA"};